import React, { useEffect } from "react";
import { trackHowToPlayViewed } from '../../utils/activityTracker';
import useAchievements from '../../hooks/useAchievements';
import { useAuth } from '../../contexts/AuthContext';
import './BibleBooksHowToPlay.scss';

const HowToPlayContent = () => (
  <>
    <h2 className="bible-books-how-to-play__title">How to Play</h2>
    <ul className="bible-books-how-to-play__list">
      <li className="bible-books-how-to-play__list-item">
        Try to guess the name of a <b>Bible book</b> chosen at random!
      </li>
      <li className="bible-books-how-to-play__list-item">
        Each guess will be checked for matching <b>Testament</b>, <b>Genre</b>, <b>Primary Author</b>, <b>Chapters</b>, and <b>Audience</b>.
      </li>
      <li className="bible-books-how-to-play__list-item">
        <span className="bible-books-how-to-play__highlight-color bible-books-how-to-play__highlight-color--blue">Blue</span> means your guess matches the book in that category.<br />
        <span className="bible-books-how-to-play__highlight-color bible-books-how-to-play__highlight-color--pink">Pink</span> means no match.
      </li>
      <li className="bible-books-how-to-play__list-item">
        Use the <b>Book Directory</b> to browse books and filter by Testament, Genre, or Audience.
      </li>
      <li className="bible-books-how-to-play__list-item">
        Guess until you find the right book.
      </li>
    </ul>
    <div className="bible-books-how-to-play__tip">
      <b>Tip:</b> After 5 attempts, you can reveal a key verse hint.
    </div>
  </>
);

const BibleBooksHowToPlay = ({ show, onClose, gameId }) => {
  const { handleNewAchievements } = useAchievements();
  const { isAuthenticated } = useAuth();
  
  // Track when the modal is shown (only for authenticated users)
  useEffect(() => {
    if (show && gameId && isAuthenticated) {
      const trackGuideView = async () => {
        const response = await trackHowToPlayViewed(gameId);
        if (response && response.newAchievements && response.newAchievements.length > 0) {
          handleNewAchievements(response.newAchievements);
        }
      };
      trackGuideView();
    }
  }, [show, gameId, isAuthenticated, handleNewAchievements]);

  if (!show) return null;

  return (
    <div className="bible-books-how-to-play" onClick={onClose}>
      <div className="bible-books-how-to-play__panel" onClick={e => e.stopPropagation()}>
        <button className="bible-books-how-to-play__close-button" onClick={onClose}>
          ✕
        </button>
        <HowToPlayContent />
      </div>
    </div>
  );
};

export default BibleBooksHowToPlay;